import React from "react";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import sectionStyles from "../styles/Section.module.css";
import styles from "../styles/Developer.module.css";
import developer from "../imgs/new-profile-pic.jpeg";
import useScrollReveal from "../hooks/useScrollReveal";

export default function Developer() {
  const [headerRef, headerVisible] = useScrollReveal();
  const [cardRef, cardVisible] = useScrollReveal();

  return (
    <div className={styles.box}>
      <Container>
        <div
          ref={headerRef}
          className={`${sectionStyles.header} ${headerVisible ? sectionStyles.visible : ""}`}
        >
          <p className={`${sectionStyles.eyebrow} ${sectionStyles.eyebrowDark}`}>THE PERSON BEHIND IT</p>
          <h2 className={`${sectionStyles.heading} ${sectionStyles.headingDark}`}>MEET YOUR DEVELOPER</h2>
        </div>
        <Row
          ref={cardRef}
          className={`${styles.card} ${sectionStyles.card} ${sectionStyles.cardHover} ${cardVisible ? styles.visible : ""}`}
        >
          <Col sm={4} className={styles.imageCol}>
            <img
              src={developer}
              alt="Esha Mathur, founder of Neko Web Studios"
              className={styles.imageContainer}
            />
          </Col>
          <Col sm={8} className={styles.textCol}>
            <h3 className={styles.name}>Esha Mathur</h3>
            <p className={styles.role}>Full Stack Software Engineer &middot; Founder, Neko Web Studios</p>
            <p className={styles.leftGridContent}>
              I'm a Full Stack Software Engineer with 3+ years of experience
              building scalable web applications using React, JavaScript,
              TypeScript, C#, and SQL Server. I run Neko Web Studios as a
              freelance practice alongside my full-time engineering work
              &mdash; handling everything from design and development to SEO
              and deployment, end to end. Outside of code, I like travelling,
              reading books, and dancing!
            </p>
          </Col>
        </Row>
      </Container>
    </div>
  );
}
